import { api } from './api';
import type { Department, Permission, User } from '@apptypes/index';

export const departmentsService = {
  list: () =>
    api.get<Department[]>('/admin/departments'),

  get: (departmentId: string) =>
    api.get<Department>(`/admin/departments/${departmentId}`),

  create: (data: { name: string; description?: string; headUserId?: string }) =>
    api.post<Department>('/admin/departments', data),

  update: (departmentId: string, data: Partial<Department>) =>
    api.put<Department>(`/admin/departments/${departmentId}`, data),

  delete: (departmentId: string) =>
    api.delete(`/admin/departments/${departmentId}`),

  // Members
  getMembers: (departmentId: string) =>
    api.get<User[]>(`/admin/departments/${departmentId}/members`),

  addMember: (departmentId: string, userId: string, branchIds?: string[]) =>
    api.post(`/admin/departments/${departmentId}/members`, { userId, branchIds }),

  removeMember: (departmentId: string, userId: string) =>
    api.delete(`/admin/departments/${departmentId}/members/${userId}`),

  // Permissions
  getPermissions: (departmentId: string) =>
    api.get<Permission[]>(`/admin/departments/${departmentId}/permissions`),

  setPermissions: (departmentId: string, permissionIds: string[]) =>
    api.put(`/admin/departments/${departmentId}/permissions`, { permissionIds }),
};
